import * as React from 'react';
import PropTypes from 'prop-types';
import ol_Map from 'ol/Map';
import ol_control_ScaleLine from 'ol/control/ScaleLine';
import { Util } from '../util';
import Map from '../map';

export class ScaleLine extends React.Component {
    constructor(props) {
        super(props);
        this.options = {
            className: undefined,
            minWidth: undefined,
            render: undefined,
            target: undefined,
            units: undefined
        };
        this.events = {
            'change': undefined,
            'change:units': undefined,
            'propertychange': undefined
        };
    }
    render() { return null; }
    componentDidMount() {
        let options = Util.getOptions(Object.assign(this.options, this.props));
        this.control = new ol_control_ScaleLine(options);
        this.context.mapComp.controls.push(this.control);
        let olEvents = Util.getEvents(this.events, this.props);
        for (let eventName in olEvents) {
            this.control.on(eventName, olEvents[eventName]);
        }
    }
}
ScaleLine['contextTypes'] = {
    mapComp: PropTypes.instanceOf(Map),
    map: PropTypes.instanceOf(ol_Map)
};